'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEntry = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _applyIdTransform = require('./applyIdTransform');

var _applyIdInvariant = require('./applyIdInvariant');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get an entry in IndexedAsyncData
 *
 * @param {Any} id an id that passes the id invariant
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to get the entry in
 * @returns {Any}
 */
var getEntry = exports.getEntry = (0, _curry2.default)(function (id, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);
  (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

  var entries = (0, _getters.getEntries)(indexedData);
  var key = (0, _applyIdTransform.applyIdTransform)(id, indexedData);

  return entries.get(key, (0, _getters.getNotSetValue)(indexedData));
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/operators/getEntry.js
// module id = 216
// module chunks = 2 3